<!-- 绑定公众号 -->
<template>
  <div>
    <div class="head-title">绑定公众号</div>
    <el-collapse style="margin-bottom: 2rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>1、只能绑定一个公众号。</p>
          <p>
            2、若您需要解绑现有的公众号，请前去
            <a
              class="help-link"
              href="https://mp.weixin.qq.com/"
              target="_blank"
              rel="noopener noreferrer"
              >公众号平台</a
            >
            解绑。
          </p>
          <p>3、需要使用第三方授权。</p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="main" v-if="isLoading">
      <div class="main-head">
        <div class="main-head-l">
          <div class="main-head-l-l">
            <template v-if="code == 0">
              <svg
                viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg"
                class="icon-warning"
              >
                <path
                  d="M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M24,31 C22.8954305,31 22,31.8954305 22,33 C22,34.1045695 22.8954305,35 24,35 C25.1045695,35 26,34.1045695 26,33 C26,31.8954305 25.1045695,31 24,31 Z M24,14 C23.1715729,14 22.5,14.6715729 22.5,15.5 L22.5,15.5 L22.5,27.5 C22.5,28.3284271 23.1715729,29 24,29 C24.8284271,29 25.5,28.3284271 25.5,27.5 L25.5,27.5 L25.5,15.5 C25.5,14.6715729 24.8284271,14 24,14 Z"
                ></path>
              </svg>
            </template>
            <template v-else>
              <svg
                viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg"
                class="icon-success"
              >
                <path
                  d="M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M34.5548098,16.4485711 C33.9612228,15.8504763 32.9988282,15.8504763 32.4052412,16.4485711 L32.4052412,16.4485711 L21.413757,27.5805811 L21.413757,27.5805811 L21.4034642,27.590855 C21.0097542,27.9781674 20.3766105,27.9729811 19.9892981,27.5792711 L19.9892981,27.5792711 L15.5947588,23.1121428 C15.0011718,22.514048 14.0387772,22.514048 13.4451902,23.1121428 C12.8516033,23.7102376 12.8516033,24.6799409 13.4451902,25.2780357 L13.4451902,25.2780357 L19.6260786,31.5514289 C20.2196656,32.1495237 21.1820602,32.1495237 21.7756472,31.5514289 L21.7756472,31.5514289 L34.5548098,18.614464 C35.1483967,18.0163692 35.1483967,17.0466659 34.5548098,16.4485711 Z"
                ></path>
              </svg>
            </template>
          </div>
          <div class="main-head-l-r" v-if="code == 0">
            <div class="main-head-l-r-t">还未绑定公众号</div>
            <div class="main-head-l-r-b">绑定后管理更高效</div>
          </div>
          <div class="main-head-l-r" v-else>
            <div class="main-head-l-r-t">绑定成功</div>
            <div class="main-head-l-r-b">绑定后管理更高效</div>
          </div>
        </div>
        <div class="main-head-r">
          <el-button v-if="code == 0" type="primary" style="padding: 0">
            <a
              style="display: inline-flex; color: #fff; padding: 0.9rem 1.5rem"
              :href="link"
              rel="opener noopener nofollow ugc"
              >前去绑定公众号</a
            >
          </el-button>
        </div>
      </div>
      <div class="divider" v-if="code == 1"></div>
      <div class="main-container" v-if="code == 1">
        <div class="cell">
          <div class="cell-l">
            <div class="cell-l-l">
              <el-image
                style="width: 4rem; height: 4rem"
                :src="info.head_img"
              ></el-image>
            </div>
            <div class="cell-l-r">
              <div class="cell-l-r-t">
                {{ info.nick_name }}
              </div>
              <div class="cell-l-r-b">
                <span
                  class="fail"
                  style="color: #f56c6c"
                  v-if="info.verify_type_info.id == -1"
                >
                  未认证企业公众号
                </span>
                <span
                  class="success"
                  style="color: #67c23a"
                  v-if="info.verify_type_info.id == 0"
                >
                  已认证企业公众号
                </span>
              </div>
            </div>
          </div>
          <div class="cell-r">
            <div class="cell-r-l">公众号二维码</div>
            <div class="cell-r-r">
              <el-image
                style="width: 6rem; height: 6rem"
                :src="info.qrcode_url"
                :preview-src-list="[info.qrcode_url]"
              ></el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bingBublicAccount",
  components: {},

  data() {
    return {
      code: "",
      link: "",
      info: {
        verify_type_info: {
          id: 0,
        },
      },
      isLoading: false,
    };
  },
  computed: {},
  mounted() {
    // ?account=13523451691&account_id=201&account_name=河南新盛捷有限公司&enterprisePhoto=http://work-1302521284.cos.ap-beijing.myqcloud.com/weijub/QQ%E6%88%AA%E5%9B%BE20211013154526.png&examineCode=039916cc56a186a18016158929053b32&id=228&password=f379eaf3c831b04de153469d1bec345e&past_time=2021-11-10 16:37:54&phone=13523451691&role_id=0&usertoken=be4e321bf67bea3e6dda0cea6bd38ead201
    const q = this.$route.query;
    if (q.account_id) {
      var storuser = {
        account: q.account,
        account_id: q.account_id,
        account_name: q.account_name,
        enterprisePhoto: q.enterprisePhoto,
        examineCode: q.examineCode,
        id: q.id,
        password: q.password,
        past_time: q.past_time,
        phone: q.phone,
        role_id: q.role_id,
        usertoken: q.usertoken,
      };
      this.tooken = storuser;
      localStroage.setItem("storuser", JSON.stringify(storuser));
    }
    this.get_authorization_code();
    this.getIfAccountPublicSet();
  },

  methods: {
    async getIfAccountPublicSet() {
      const { data: res } = await this.axios({
        url: "/crm/AcountPublic/ifAccountPublicSet",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
        }),
      });
      this.isLoading = true;
      this.code = res.code.toString();
      if (res.code == 1) {
        this.info = res.data;
      }
    },
    async get_authorization_code() {
      const { data: res } = await this.axios({
        url: "/crm/AcountPublic/get_authorization_code",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
        }),
      });
      console.log("link", res);
      this.link = res;
    },
    onToBind() {
      window.open(this.link);
    },
  },
};
</script>
<style  lang="scss" scoped>
.main {
  box-shadow: 0 0.2rem 1.2rem 0 rgba(0, 0, 0, 0.1);
  margin-top: 1rem;
  &-head {
    &-label {
      font-size: 1.4rem;
      color: #666;
      margin-right: 2.4rem;
    }
  }
  &-grid {
    margin-top: 2.4rem;
    .grid-item {
      display: inline-flex;
      align-items: center;
      padding: 2.4rem;
      background-color: #e1f0ff;
      border-radius: .4rem;
      &-l {
        display: inline-flex;
        align-items: center;
        margin-right: 8rem;
        &-l {
          background-color: #fff;
          border-radius: .6rem;
          width: 5rem;
          height: 5rem;
          margin-right: 1.2rem;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          .icon {
            color: #00aaee;
            font-size: 2.2rem;
          }
        }
        &-r {
          font-size: 1.4rem;
          color: #252525;
        }
      }
      &-r {
        width: 7rem;
      }
    }
  }
}

.icon-warning {
  width: 4rem;
  height: 4rem;
  fill: #f96460;
}
.icon-success {
  width: 4rem;
  height: 4rem;
  fill: #67c23a;
}
.main-head {
  margin-top: 4rem;
  display: flex;
  justify-content: space-between;
  padding: 3rem 2.4rem;
  &-l {
    display: flex;
    align-items: center;
    &-r {
      margin-left: 1.6rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &-t {
        font-size: 1.6rem;
      }
      &-b {
        margin-top:0.8rem;
        font-size: 1.2rem;
        color: rgb(131, 131, 131);
      }
    }
  }
}

.main-container {
  margin-top: 5rem;
}

.cell {
  display: flex;
  justify-content: space-between;
  padding: 3rem 2.4rem;
  &-l {
    display: flex;
    align-items: center;
    &-l {
      padding: 0.8rem;
      background-color: #fff;
      border: 0.1rem  solid #eeeeee;
      border-radius: 1rem;
    }
    &-r {
      margin-left: 1.6rem;
      &-t {
        font-size: 1.6rem;
      }
      &-b {
        margin-top: 0.8rem;
        font-size: 1.2rem;
        color: rgb(131, 131, 131);
      }
    }
  }
  &-r {
    display: flex;
    align-items: flex-end;
    &-l {
      margin-right: 1.6rem;
      font-size: 1.2rem;
      color: rgb(131, 131, 131);
      margin-bottom: 0.8rem;
    }
  }
}
.divider {
  display: block;
  height: 0.1rem;
  margin: 2.4rem;
  background-color: #ebebeb;
  position: relative;
}
</style>